import { MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { AdministrationRouteWorkflow } from './types';
import { StyledSelect } from '../StyledSelect/StyledSelect';

type WorkflowSelectorProps = {
  workflowsWithRoutes: AdministrationRouteWorkflow[];
  onWorkflowSelected: (workflow: AdministrationRouteWorkflow) => void;
};

/**
 * @param workflowsWithRoutes List of workflows with administration routes.
 * @return A dropdown selector to select a workflow. On init, pre-selects the cached workflow if available. Else first available in the list.
 */
const WorkflowSelector = ({ workflowsWithRoutes, onWorkflowSelected }: WorkflowSelectorProps) => {
  const [selectedWorkflow, setSelectedWorkflow] = useState<AdministrationRouteWorkflow | null>(null);

  useEffect(() => {
    // On init, try to select the cached workflow, if it exists and is still valid. Else select workflow 0.
    const lastCachedWorkflowObject = JSON.parse(localStorage.getItem('last_workflow') || 'null');
    if (lastCachedWorkflowObject) {
      const matchingWorkflow = workflowsWithRoutes.find(wf => wf.workflow.id === lastCachedWorkflowObject.id && wf.workflow.version === lastCachedWorkflowObject.version.toString());
      if (matchingWorkflow) {
        setSelectedWorkflow(matchingWorkflow);
        onWorkflowSelected(matchingWorkflow);
      } else {
        setSelectedWorkflow(workflowsWithRoutes[0] || null);
        onWorkflowSelected(workflowsWithRoutes[0] || null);
      }
    }
  }, [workflowsWithRoutes]);

  return (
    <StyledSelect
      value={selectedWorkflow?.workflow[0].label || ''}
      disabled={!workflowsWithRoutes || workflowsWithRoutes.length === 0}
      onChange={(e) => {
        const selected = workflowsWithRoutes.find(wf => wf.workflow[0].label === e.target.value) || null;
        setSelectedWorkflow(selected);
        onWorkflowSelected(selected);
      }}
      variant='outlined'
    >
      {workflowsWithRoutes && workflowsWithRoutes.map((wf, index) => {
        return (
          <MenuItem key={index} value={wf.workflow[0].label} sx={{ justifyContent: 'space-between', pl: 2 }}>
            <Typography>{wf.workflow[0].label}</Typography>
          </MenuItem>
        );
      })}
    </StyledSelect>
  );
};

export default WorkflowSelector;
